import {ALLOWED_GRADUATION_YEARS} from 'shared/utils';
import React, {useEffect} from 'react';
import {useFormikContext} from 'formik';
import {HighSchoolInformationForm} from 'src/types/onboarding';
import styles from './styles.module.scss';
import BaseStep from 'shared/registration/components/steps/base-step';
import classnames from 'classnames';
import Citizenship from '../Citizenship/index';
import FormikDropdown from 'src/components/formik-dropdown';
import {useMediaQuery} from '../../../../hooks/useMediaQuery';
import HighSchoolInstitutionStep from '../../../../views/high-school/Onboarding/institution-step';
import Label from 'shared/components/label';
import Fieldset from 'shared/components/fieldset';
import {VISITED_ELIGIBILITY} from '../../../Onboarding/utils';
import FormikAddressInput from 'src/components/inputs/formik-address-input/formik-address-input';
import SuggestAddressModal from 'src/components/SuggestAddressModal';
import CannotVerifyAddressModal from 'src/components/CannotVerifyAddressModal';

const dropdownYearOptions = ALLOWED_GRADUATION_YEARS.map((year) => ({
  value: year,
  text: year.toString(),
}));

const Eligibility = () => {
  const form = useFormikContext<HighSchoolInformationForm & {_addressSuggestion: boolean}>();
  const mq = useMediaQuery();

  useEffect(() => {
    if (!form.values.highSchoolInfo.graduationYear) {
      form.setFieldValue('highSchoolInfo.graduationYear', dropdownYearOptions[0].value);
    }

    window.localStorage.setItem(VISITED_ELIGIBILITY, 'true');
  }, []);

  return (
    <BaseStep
      stepHeader="Qualify for Micro Scholarships"
      subHeader="Great Job! You’re on your way to earning micro-scholarships for your hard work! In order to receive micro-scholarships
      you’ll need to answer the following questions to make sure you’re eligible:"
    >
      <div className={styles.grid}>
        <HighSchoolInstitutionStep />
        <Label
          className={classnames(styles.sectionLabel, {'mt-32': mq.SM_AND_DOWN})}
          required
          noTopPadding={mq.MD_AND_UP}
        >
          Projected Graduation Year
          <FormikDropdown options={dropdownYearOptions} name="highSchoolInfo.graduationYear" />
        </Label>
      </div>
      <Fieldset className="mt-32 shared-address-input address-step">
        <Fieldset.Legend className={styles.sectionLabel} required>
          Address
        </Fieldset.Legend>
        <FormikAddressInput />
      </Fieldset>
      <Fieldset className="mt-32 shared-address-input address-step">
        <Fieldset.Legend className={styles.sectionLabel} required>
          Are you a U.S. citizen or permanent resident?
        </Fieldset.Legend>
        <Citizenship />
        {form.values._addressSuggestion && (
          <SuggestAddressModal
            onUpdate={form.submitForm}
            confirmationText="Confirm and Complete Onboarding"
          />
        )}
        {form.values._addressSuggestion === false && (
          <CannotVerifyAddressModal
            onUpdate={form.submitForm}
            confirmationText="Confirm and Complete Onboarding"
          />
        )}
      </Fieldset>
    </BaseStep>
  );
};

export default Eligibility;
